<template>
  <div class="w-full shadow bg-white mb-4 p-4 inline-flex items-center" v-if="file">
    <div class="inline-flex items-center text-sm font-semibold text-grey-darker hover:text-green-dark cursor-pointer">
      <font-awesome-icon :icon="['fas', 'file-pdf']" class="mr-4" size="2x" />
      <a v-on:click="requestFileUrl('show')" :title="file.name">
        {{ file.name }}
      </a>
    </div>
    <base-dropdown class="ml-auto">
      <div slot="button" class="flex items-center">
        <div class="btn-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
      <div slot="items">
        <a v-if="$navigate.isAllowed('proceed', 'file-read')" v-on:click="requestFileUrl('download')" class="inline-block w-full px-3 py-2 mt-1 hover:bg-grey-lighter rounded cursor-pointer">
          <span class="inline-block">Download</span>
        </a>
        <a v-if="$navigate.isAllowed('proceed', 'file-delete')" v-on:click="remove(file)" class="inline-block w-full px-3 py-2 mt-1 hover:bg-grey-lighter text-red rounded cursor-pointer">
          <span class="inline-block">Verwijder</span>
        </a>
      </div>
    </base-dropdown>
  </div>
  <div v-else-if="$navigate.isAllowed('proceed', 'file-write')" class="document border-2 border-dashed bg-transparent cursor-pointer hover:bg-white" @click="create()">
    <div class="inline-flex items-center text-sm font-semibold text-grey-darker">
      <font-awesome-icon :icon="['fas', 'plus']" class="mr-4" size="lg" />
      <span title="Nieuw bestand toevoegen">{{ emptyText }}</span>
    </div>
  </div>
</template>

<script>
import ApiService from '@/common/api.service';
import { API_URL } from '@/common/config';
import NavigatePerimeter from '@/perimeters/navigate';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  props: ['file', 'type', 'emptyText'],
  perimeters: [NavigatePerimeter],
  components: { FontAwesomeIcon },
  methods: {
    async requestFileUrl(type) {
      const win = window.open();
      const { data } = await ApiService.get(`/v1/files/${this.file.id}/hash`);

      win.location = `${API_URL}/files/${type}/${data}`;
      win.focus();
    },
    create() {
      this.$emit('click', this.type);
    },
    remove() {
      this.$emit('remove', { file: this.file, type: this.type });
    }
  }
};
</script>
